import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=ac5a3d96&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=ac5a3d96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports